import { css } from '@emotion/react';

export default $ => css`
  .sidebar {
    position: fixed;
    left: 0;
    top: ${$.navbarHeight};
    background-color: ${$.white};
    bottom: 0;
    z-index: 1000;

    display: flex;
    flex-direction: row;

    > .nav.nav-tabs {
      flex: 0 0 ${$.sidebarButtonWidth};
      flex-direction: column;
      flex-wrap: nowrap;

      > .nav-item {
        > .nav-link {
          border-radius: 0;
          border-width: 0 0 0 5px;
          border-color: ${$.white};
          width: ${$.sidebarButtonWidth};
          color: ${$.primaryMain};
          text-align: center;

          > * {
            opacity: 0.9;
          }

          &.active {
            background-color: ${$.gray100};
            border-color: ${$.blue};
            color: ${$.infoMain};
            width: 100%;

            > * {
              opacity: 1;
            }
          }
        }

        .dimo-icon {
          font-size: 1.9rem;
        }

        .fa,
        .icon {
          font-size: 1.5rem;
        }
      }
    }

    > .tab-content {
      flex: 0 0 ${$.sidebarContentWidth};
      background-color: ${$.gray100};

      &.empty {
        flex: 0 0 0;
      }

      > .tab-pane {
        padding-top: ${$.mainContainerGap};
      }

      > .tab-pane.home {
        display: flex;
        flex-direction: column;
        align-items: center;

        > :not(:first-of-type) {
          margin-top: 42px;
        }

        .sidebar-status-icon {
          width: 75%;
        }
      }
    }
  }

  .sidebar-status-icon {
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-template-rows: repeat(3, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 0px;

    :nth-of-type(1) {
      grid-area: 1 / 1 / 3 / 2;
      align-self: stretch;
      height: 1em;
      text-align: center;
      font-size: 4rem;
    }

    :nth-of-type(2) {
      grid-area: 1 / 2 / 2 / 3;
      background-color: ${$.gray100};
      height: 1.5em;
      text-align: center;
    }

    :nth-of-type(3) {
      grid-area: 2 / 2 / 3 / 3;
      background-color: ${$.gray100};
      height: 1.5em;
      text-align: center;
    }

    :nth-of-type(4) {
      grid-area: 3 / 1 / 4 / 3;
    }
  }

  @media (max-width: 768px) {
    .nav-item {
      width: 220px;
    }

    .nav-link {
      display: inline-flex;
      position: relative;
    }

    .nav-text {
      position: absolute;
      bottom: 8px;
      padding-left: 48px;
      font-size: 14px;
      white-space: nowrap;
    }
  }
`;
